import { Button, Stack, Typography } from "@mui/material";
import { useState } from "react";
import AuthorizedBox from "@entrilia/shared/components/AuthorizedBox";
import ScrollableFlexContainer from "@entrilia/shared/components/ScrollableFlexContainer";
import useResizeObserver from "@entrilia/shared/hooks/useResizeObserver";
import NoConfigurationDialogIcon from "@entrilia/shared/icons/NoConfigurationDialogIcon";

interface Props {
  onConfigure: () => void;
}

const WidgetNotConfigured = ({ onConfigure }: Props) => {
  const [stackEl, setStackEl] = useState<HTMLDivElement | null>(null);
  const [containerWidth, setContainerWidth] = useState(0);
  const [containerHeight, setContainerHeight] = useState(0);
  const showLogo = containerWidth >= 160 && containerHeight >= 190;
  const showTitle = containerWidth >= 160 && containerHeight >= 78;
  const showSubText = containerWidth >= 250 && containerHeight >= 115;

  const showTextBox = showTitle || showSubText;

  useResizeObserver(stackEl, {}, (entries) => {
    const width = entries[0]?.target.clientWidth;
    const height = entries[0]?.target.clientHeight;
    setContainerWidth(width || 0);
    setContainerHeight(height || 0);
  });

  return (
    <ScrollableFlexContainer
      ref={(el) => setStackEl(el)}
      scrollContainerSx={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center" }}
    >
      <Stack spacing={2} sx={{ alignItems: "center", justifyContent: "center", flex: 1 }}>
        {showLogo && <NoConfigurationDialogIcon sx={{ width: 81, height: 80 }} />}

        {showTextBox && (
          <Stack spacing={1} sx={{ alignItems: "center", justifyContent: "center" }}>
            {showTitle && <Typography variant="h6">Widget not configured</Typography>}
            {showSubText && (
              <Typography sx={{ textAlign: "center" }}>Please configure the widget to view the data</Typography>
            )}
          </Stack>
        )}

        <AuthorizedBox permissions={["ManageReports", "ManageDashboards"]}>
          <Button variant="contained" onClick={onConfigure}>
            Configure
          </Button>
        </AuthorizedBox>
      </Stack>
    </ScrollableFlexContainer>
  );
};

export default WidgetNotConfigured;
